import { consentFieldMap } from "../Components/EConsent/Builder/blockTypes";

export const createConsentBlockSkeleton = (type: string) => ({
  ...consentFieldMap(type),
  type,
});
